<app-load-general [load]="load"></app-load-general>
@if (Data) {
  <div class="p-4 rounded-lg flex flex-col gap-3">
    <div class="flex items-center justify-between">
      <div class="text-general-title text-(--color-text-primary)!">
        {{ Data.title }}
      </div>

      @if (
        Data.idPage != 2 &&
        Data.idPage != 4 &&
        Data.idPage != 15 &&
        Data.idPage != 18 &&
        Data.idPage != 20 &&
        Data.idPage != 23 &&
        Data.idPage != 26 &&
        Data.idPage != 27 &&
        Data.idPage != 29 &&
        Data.idPage != 30 &&
        Data.idPage != 33 &&
        Data.idPage != 39 &&
        Data.idPage != 1044 &&
        Data.idPage != 1045 &&
        Data.idPage != 1046 &&
        Data.idPage != 1039
      ) {
        <div class="flex justify-end">
          <div class="flex gap-4">
            <button matButton class="text-(--color-text-primary)!" (click)="expandAll()">
              {{ 'general-pages.general-front.expand' | translate }}
            </button>
            <button matButton class="text-(--color-text-primary)!" (click)="collapseAll()">
              {{ 'general-pages.general-front.collapse' | translate }}
            </button>
          </div>
        </div>
      }
    </div>
    @if (Data.section) {
      @for (sectionData of Data.section; track sectionData; let sectionIndex = $index) {
        <div
          class="flex flex-col gap-3"
          [ngClass]="{
            'hidden!': !viewForm(sectionData.idSection),
          }"
        >
          <div class="flex flex-col gap-3">
            @if (
              sectionData.title &&
              sectionData.border &&
              sectionData.idSection !== 0 &&
              sectionData.idSection !== 6 &&
              sectionData.idSection !== 8 &&
              sectionData.idSection !== 21 &&
              sectionData.idSection !== 46 &&
              sectionData.idSection !== 47 &&
              sectionData.idSection !== 48 &&
              sectionData.idSection !== 49 &&
              sectionData.idSection !== 1054 &&
              sectionData.idSection !== 1064 &&
              sectionData.idSection !== 1055
            ) {
              <div class="h-15 sticky top-0 z-10 bg-(--brand-azul-fondo-general) rounded-4xl">
                <div
                  class="px-4 text-general-subtitle text-(--color-text-primary)! w-full h-full flex items-center"
                >
                  Sección: {{ sectionData.title }}
                  @if (edit) {
                    :ID Seccion:{{ sectionData.idSection }}
                  }
                </div>
              </div>
            }

            @for (forms of sectionData.forms; track $index) {
              @if (forms.form && forms.generateForm && forms.collectionFormsControls) {
                @if (
                  sectionData.idSection !== 8 &&
                  sectionData.idSection !== 0 &&
                  sectionData.idSection !== 6 &&
                  sectionData.idSection !== 21 &&
                  sectionData.idSection !== 25 &&
                  sectionData.idSection !== 29 &&
                  sectionData.idSection !== 31 &&
                  sectionData.idSection !== 46 &&
                  sectionData.idSection !== 47 &&
                  sectionData.idSection !== 48 &&
                  sectionData.idSection !== 49 &&
                  sectionData.idSection !== 1054 &&
                  sectionData.idSection !== 1063 &&
                  sectionData.idSection !== 1064 &&
                  sectionData.idSection !== 1055
                ) {
                  <div
                    class="flex flex-col gap-3"
                    [ngClass]="{
                      'hidden!':
                        !viewForm(sectionData.idSection) ||
                        (forms.generateForm.formGroups?.hide &&
                          !forms.generateForm.formGroups?.isRepeatable),
                    }"
                  >
                    <app-form-general
                      [id]="forms.generateForm.formGroups?.idForm"
                      [edit]="edit"
                      [idSection]="sectionData.idSection"
                      [ruleInputForm]="Data.rules.ruleInputForm"
                      [tollArray]="tollArray"
                      [collectionFormsControls]="forms.collectionFormsControls"
                      [generateForm]="forms.generateForm"
                      [quotationId]="quotationId"
                      [isExpasion]="forms.isExpasion ?? true"
                      [toll]="tollArray.length ? true : false"
                      (emitFunctionTool)="emitButtonForm($event)"
                      (emitButton)="emitButton($event)"
                      [hidenScrollRight]="sectionIndex == Data.section.length - 1 ? true : false"
                      [hidenScrollLeft]="sectionIndex == 0 ? true : false"
                    ></app-form-general>
                  </div>
                }

                @if (Data.idPage == 4 || Data.idPage == 18) {
                  <app-quotation
                    [initTicketId]="null"
                    [initQuotationId]="quotationId"
                    [Page]="Data.idPage"
                  ></app-quotation>
                }

                @if (Data.idPage == 2) {
                  <app-payments-docs
                    [quotationId]="quotationId"
                    [cotStatus]="cotStatus?.deS_STATUS || 'COMPRADA'"
                  ></app-payments-docs>
                }
                @if (Data.idPage == 15) {
                  <app-quotation [Page]="Data.idPage"></app-quotation>
                  <!-- <app-new-quotation></app-new-quotation> -->
                }
                @if (sectionData.idSection == 29) {
                  <app-analysis [quotationId]="quotationId"></app-analysis>
                }
                @if (sectionData.idSection == 25) {
                  <app-bureau-consultation [quotationId]="quotationId"></app-bureau-consultation>
                }
                @if (sectionData.idSection == 31) {
                  <app-summary [quotationId]="quotationId"></app-summary>
                }
                @if (sectionData.idSection == 46) {
                  <app-confirm-client [quotationId]="quotationId"> </app-confirm-client>
                }
                @if (sectionData.idSection == 47) {
                  <app-administrative [quotationId]="quotationId"> </app-administrative>
                }
                @if (sectionData.idSection == 48) {
                  <app-promise-letter [quotationId]="quotationId"> </app-promise-letter>
                }
                @if (sectionData.idSection == 49) {
                  <app-capture-data-suppliers [quotationId]="quotationId">
                  </app-capture-data-suppliers>
                }
                @if (sectionData.idSection == 1054) {
                  <app-contracts [quotationId]="quotationId"> </app-contracts>
                }
                @if (sectionData.idSection == 1055) {
                  <app-gps [quotationId]="quotationId"> </app-gps>
                }
                @if (sectionData.idSection == 1063) {
                  <app-modify-dates [quotationId]="quotationId"> </app-modify-dates>
                }
                @if (Data.idPage == 1045) {
                  <app-task-list
                    [quotationId]="quotationId"
                    [cotStatus]="cotStatus"
                  ></app-task-list>
                }
                @if (Data.idPage == 1046) {
                  <app-financial-statement [quotationId]="quotationId"></app-financial-statement>
                }
              }
            }
          </div>
        </div>
      }
    }
  </div>
}
